import { Box, Card, CardContent, Typography } from '@mui/material';
import type { Market } from '../dataProvider/types';
import type { StorePerfBand as Band } from './storePerformanceModel';
import { StorePerformanceTable } from './StorePerformanceTable';
import { StorePerformanceChart } from './StorePerformanceChart';

/**
 * One full-width market band: the store leaderboard table and the Recharts bar
 * chart beneath it. A band is wholly self-contained per market; a dual-market
 * brand appears as one row here and one row in the other band, never merged.
 * These are counts and a percentage, so there is no currency on this surface.
 */

const MARKET_NAME: Record<Market, string> = {
  uk: 'United Kingdom',
  us: 'United States',
  ie: 'Ireland',
};

export const StorePerformanceBand = ({ band }: { band: Band }) => (
  <Card
    variant="outlined"
    data-testid={`sp-band-${band.market}`}
    sx={{ mb: 3 }}
  >
    <CardContent>
      <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
        {MARKET_NAME[band.market]}
      </Typography>

      <StorePerformanceTable
        ranked={band.ranked}
        subFloor={band.subFloor}
        medianRate={band.medianRate}
      />

      <Box sx={{ mt: 3 }}>
        <StorePerformanceChart rows={band.ranked} />
      </Box>
    </CardContent>
  </Card>
);
